var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import { Stack, Typography } from '@mui/material';
import { CloseFileCardIcon } from '../icons';
var CommonDialog = function (_a) {
    var open = _a.open, onClose = _a.onClose, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.maxWidth, maxWidth = _c === void 0 ? 'sm' : _c, _d = _a.fullWidth, fullWidth = _d === void 0 ? false : _d, children = _a.children, _e = _a.titleColor, titleColor = _e === void 0 ? "#1F275C" : _e, _f = _a.disablePadding, disablePadding = _f === void 0 ? false : _f, _g = _a.isDialogRoot, isDialogRoot = _g === void 0 ? false : _g, _h = _a.sx, sx = _h === void 0 ? {} : _h, dialogTitle = _a.dialogTitle, _j = _a.showCloseIcon, showCloseIcon = _j === void 0 ? true : _j, headerActions = _a.headerActions;
    return (React.createElement(Dialog, { open: open, onClose: onClose, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", className: "".concat(className), maxWidth: maxWidth, fullWidth: fullWidth, sx: __assign({ '& .MuiPaper-root.MuiPaper-elevation': {
                padding: disablePadding ? '0px !important' : '1rem',
                borderRadius: disablePadding ? '0px !important' : '0.625rem',
                minHeight: disablePadding ? '65vh' : '7.625rem',
                '& .MuiDialogContent-root': {
                    alignItems: disablePadding ? 'start' : 'center',
                },
            } }, sx) },
        React.createElement(Stack, { direction: "row", justifyContent: 'space-between', alignItems: 'center' },
            typeof dialogTitle === 'string' || typeof dialogTitle === 'number' ? (React.createElement(Typography, { variant: "body1", fontWeight: 600, color: titleColor }, dialogTitle)) : (dialogTitle),
            React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 1 },
                headerActions,
                showCloseIcon && (React.createElement(IconButton, { sx: { cursor: 'pointer' }, onClick: onClose },
                    React.createElement(CloseFileCardIcon, null))))),
        React.createElement(Stack, { sx: sx }, children)));
};
export default CommonDialog;
